<template>
<div>
  <div class="herobg">

    <router-link :to="{ name: 'Home', query: this.$store.state.query }">
      <img class="logo ut-mt-1 ut-mb-8" src="@/assets/styles/frontend-library/images/logo-openagent-green-white.svg" alt="OpenAgent.com.au" width="200"></router-link>

    <div v-if="formtype == 'shortlist'" class="introtext2">Create a personalised shortlist of agents</div>
    <div v-for="(agent, key) in this.agentdata">
      <img class="headshots ut-cursor-pointer ut-headshot-sm ut-content-center ut-flex" :class="`headshots${key}`" v-bind:src="agent.AgentImageLink" />
    </div>
    <div v-if="formtype == 'appraisal'" class="introtext">Request an appraisal from <span v-if="this.agentdata.length == 1" class="ut-font-semibold">{{this.agentdata[0].AgentName}}</span><span v-if="this.agentdata.length > 1" class="ut-font-semibold">{{this.agentdata.length}}
        agents</span></div>

  </div>
  <div v-if="formtype == 'shortlist'" class="stageouter">
    <div class="stage ut-flex ut-flex-initial">
      <div class="stageblock ut-m-0">
        <div class="circle active"><span v-if="stage == 'yoursit'">1</span><img v-if="stage == 'aboutyou'" src="@/assets/styles/frontend-library/images/check-white.svg"></div>
        <span class="ctext" :class="{ 'active': stage == 'yoursit' }">Your<br> situation</span>
      </div>

      <div class="styleline">
      </div>

      <div class="stageblock stageblock2">
        <div class="circle" :class="{ 'active': stage == 'aboutyou' }">2</div>
        <span class="ctext" :class="{ 'active': stage == 'aboutyou' }">About<br> you</span>
      </div>

    </div>
  </div>

  <div v-if="formtype == 'appraisal'" class="stageouter">
    <div class="stage ut-flex ut-flex-initial">
      <div class="stageblock ut-m-0">
        <div class="circle active"><span v-if="stage == 'first'">1</span><img v-if="stage == 'second'" src="@/assets/styles/frontend-library/images/check-white.svg"></div>
        <span class="ctext" :class="{ 'active': stage == 'first' }">Contact<br> details</span>
      </div>

      <div class="styleline">
      </div>

      <div class="stageblock stageblock2">
        <div class="circle" :class="{ 'active': stage == 'second' }">2</div>
        <span class="ctext" :class="{ 'active': stage == 'second' }">Property<br> information</span>
      </div>

    </div>
  </div>

</div>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    stage: null,
    formtype: null,
    agentdata: null,
  },
  computed: {
    radioButtonState() {
      if (this.selectedValue == this.radioValue) {
        this.selected = true;
      }

      return this.selected;
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.herobg {
    background-color: #1A5A4E;
    // background: linear-gradient(rgba(62, 106, 113, 0.80), rgba(62, 106, 113, 0.80)),url('../assets/images/herobg.jpg');
    @apply ut-text-left ut-px-6 ut-pt-4 ut-pb-1 ut-text-N0 ut-bg-center ut-bg-no-repeat bg-cover;

    @screen md {
        @apply ut-pb-2;
    }

    .logo {
        width: 125px;
    }

    .introtext {
        @apply ut-text-xl ut-mx-0 ut-mb-8 ut-ml-4 ut-inline-block;
        max-width: 225px;
    }
    .introtext2 {
        @apply ut-text-xl ut-mx-0 ut-mb-8;
        max-width: 225px;
    }
}

.stageouter {
    @apply ut-px-4;
}

.headshots {
    width: 51px;
    height: 51px;
    float: left;
    box-shadow: 0 0 0 3px #fff;
    position: relative;
    z-index: 3;

    &.headshots1 {
        margin-left: -20px;
        z-index: 2;
    }

    &.headshots2 {
        margin-left: -20px;
        z-index: 1;
    }
}

.stage {
    @apply ut-py-6;
    margin: 0 0 20px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    .circle {
        @apply ut-text-center ut-text-N0 ut-inline-block ut-mr-2 ut-align-bottom;
        background-color: #748284;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        line-height: 1.9rem;
        &.active {
            @apply ut-bg-Gnew;
        }

        img {
          padding-top: 4px;
        }

    }
    .ctext {
        @apply ut-inline-block;
        color: #7f7f7f;
        &.active {
            color: #000;
        }
    }
}

.styleline {
    width: 30%;
    max-width: 200px;
    margin-top: 20px;
    margin-left: 110px;
    position: absolute;
    border-bottom: 1px solid rgba(#979797, 0.3);
    z-index: 0;
}

.stageblock {
  background-color: #fff;
  z-index: 1;
}

.stageblock2 {
    padding-left: 10px;
}
</style>
